export const searchAPI = "https://ws.geonorge.no/adresser/v1/sok";
export const ssrAPI = "https://ws.geonorge.no/stedsnavn/v1/navn";
//export const norgeCoor = [60.14, 10.25];  // bruker latLng når det endres
export const zoom = 14; // Zoom på index når markør plasseres
export const pdfZoom = 14.5; // Zoom for kartutsnitt i PDF
export const norgeCoorAll = [65.14, 17.65];
export const zoomAll = 5; // vise fullsize Norge
export const kartAPI =
  "https://cache.kartverket.no/v1/wmts/1.0.0/topo/default/webmercator/";

export const topoLayer = "topo4";
